import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireVerification = false }) => {
      const { currentUser, isLoading: authIsLoading } = useAuth();
  const [isVerified, setIsVerified] = useState(false);
  const [verificationChecked, setVerificationChecked] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!authIsLoading) {
      if (currentUser) {
        if (requireVerification) {
          setIsVerified(currentUser.verified === true);
        }
        setVerificationChecked(true);
      } else {
        setVerificationChecked(true);
      }
    }
  }, [currentUser, authIsLoading, requireVerification]);

  if (authIsLoading || (currentUser && requireVerification && !verificationChecked)) {
    return <div className="loading-container">Checking permissions...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (requireVerification && !isVerified) {
    return (
      <div className="access-denied-container">
        <h2>Access Denied</h2>
        <p>You need administrator verification to access this page. Your current status is: {currentUser.verified ? 'Verified' : 'Not Verified'}.</p>
        <button onClick={() => window.location.href = '/'}>Return to Home</button>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute; 